module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.name === 'goods') ? _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_vm._v("\n    设置\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.base.title),
      callback: function($$v) {
        _vm.$set(_vm.base, "title", $$v)
      },
      expression: "base.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "副标题"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.base.subtitle),
      callback: function($$v) {
        _vm.$set(_vm.base, "subtitle", $$v)
      },
      expression: "base.subtitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "组件间距"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.base.padded),
      callback: function($$v) {
        _vm.$set(_vm.base, "padded", $$v)
      },
      expression: "base.padded"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择商品"
    }
  }, [(_vm.data[0].item_id) ? _c('div', {
    staticClass: "goods-card"
  }, [_c('div', {
    staticClass: "goods",
    class: _vm.config.style
  }, [_c('img', {
    staticClass: "thumbnail",
    attrs: {
      "src": _vm.data[0].img_url || (_vm.config.style === 'card' ? 'https://fakeimg.pl/80x80/EFEFEF/CCC/?text=img&font=lobster' : 'https://fakeimg.pl/288x120/EFEFEF/CCC/?text=img&font=lobster')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('div', {
    staticClass: "goods-title"
  }, [_vm._v("\n                " + _vm._s(_vm.data[0].item_name || '商品标题') + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "sales-num"
  }, [_c('i', {
    staticClass: "iconfont icon-user-friends"
  }), _vm._v(_vm._s(_vm.data[0].sales || 0))]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v("\n                价格： ¥" + _vm._s(_vm.data[0].price / 100) + "\n              ")])])])]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "round": ""
    },
    on: {
      "click": _vm.showGoods
    }
  }, [_vm._v("选择商品")])], 1)], 1)], 1), _vm._v(" "), _c('GoodsSelect', {
    attrs: {
      "items-visible": _vm.itemVisible,
      "get-status": _vm.setItemStatus,
      "rel-items-ids": _vm.relItemsIds,
      "limit-num": 1
    },
    on: {
      "chooseStore": _vm.pickItem,
      "closeStoreDialog": _vm.hideGoods
    }
  })], 1) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5ecfeca7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ecfeca7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template_editor/goods.vue
// module id = 2755
// module chunks = 0